import type { HTMLAttributes, ReactNode } from 'react'

type EsBadgeTone = 'default' | 'alert' | 'quiet' | 'riskHigh' | 'riskMedium' | 'riskLow'

const toneClass: Record<EsBadgeTone, string> = {
  default: 'bg-es-white text-es-deep shadow-[0_1px_4px_rgba(11,36,64,0.1)]',
  alert: 'bg-es-navy text-es-cyan',
  quiet: 'bg-es-soft text-es-body',
  riskHigh: 'bg-red-50 text-es-riskHigh border border-red-200',
  riskMedium: 'bg-amber-50 text-es-riskMedium border border-amber-200',
  riskLow: 'bg-emerald-50 text-es-riskLow border border-emerald-200',
}

export function EsBadge({
  tone = 'default',
  className = '',
  children,
  ...rest
}: HTMLAttributes<HTMLSpanElement> & {
  tone?: EsBadgeTone
  children: ReactNode
}) {
  return (
    <span
      className={`font-esDisplay font-semibold text-sm leading-none rounded-full px-4 py-2 inline-block ${toneClass[tone]} ${className}`}
      {...rest}
    >
      {children}
    </span>
  )
}

export function riskBadgeTone(level: string | null | undefined): EsBadgeTone {
  const n = (level || '').toLowerCase()
  if (n === 'high') return 'riskHigh'
  if (n === 'medium' || n === 'med') return 'riskMedium'
  if (n === 'low') return 'riskLow'
  return 'quiet'
}
